const t=a=>a.flatMap((a=>[a,...t(a.subcategories??[])]));export{t as flattenCategoryTree};
